export default "__VITE_ASSET__P$vvit7Y__"